module.exports = __webpack_public_path__ + "ico/favicon_57.png";